import React from 'react';
import { Box } from '@material-ui/core';
import Profile from './profile/Profile';
import NavigationMenu from './navigationMenu/NavigationMenu';

const MobileNavigation = () => {
  return (
    <Box margin="0px -16px">
      <Profile />
      <NavigationMenu />
    </Box>
  );
};

export default MobileNavigation;
